import React, { Component } from 'react';

class Error extends Component {
    state = {  }
    render() { 
        return <h1>Erroraaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa</h1>;
    }
}
 
export default Error;